
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.829 21.312a12.043 12.043 0 002.9-7.86c0-6.684-5.418-12.102-12.102-12.102S1.525 6.768 1.525 13.452s5.418 12.102 12.102 12.102a12.05 12.05 0 007.413-2.535l-.027.021 7.622 7.61 1.766-1.766zm-9.146 1.728c-5.302 0-9.6-4.298-9.6-9.6s4.298-9.6 9.6-9.6a9.6 9.6 0 019.6 9.6 9.6 9.6 0 01-9.6 9.6z"}})])
          )
        }
      }
    